import { AuthClient } from '@supabase/auth-js';
import { config, isConfigured } from './config';

type AuthClientInstance = InstanceType<typeof AuthClient>;

/**
 * O Supabase no browser serve só para entrar (Google ou código por email): usamos apenas o
 * cliente de Auth. Os dados passam sempre pela nossa API, que aplica as regras de acesso.
 */
export const auth: AuthClientInstance | null = isConfigured
  ? new AuthClient({
      url: `${config.supabaseUrl}/auth/v1`,
      headers: { apikey: config.supabaseKey!, Authorization: `Bearer ${config.supabaseKey!}` },
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    })
  : null;
